var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"common-report unit-coutry-turnover-set-s"},[_c('qcentriscountry-relation'),_c('qcentriscountry-allocation')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }